<template>
    <div>
        <div>
            <el-input style="width: 220px" class="marr4" clearable size="mini" :placeholder="$t('yewuPM_product_name_specification')" v-model="cpvc_name">
            </el-input>        <el-button class="marB10" icon="el-icon-search" circle @click="searchcpFun " size="mini" ></el-button>

            <el-table class="mrt10" @row-click="showggFun" @row-dblclick="chooseRowFun" ref="table"　size="mini" :height="tableHeight" border :data="cptableData" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
                <!--                    <el-table-column label="序号" align="center" type="index" width="50px"></el-table-column>-->
                <el-table-column align="center" :label="$t('yewuPM_product_category_id')" prop="i_pztypeid" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_product_id')" prop="i_pzid" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_product_category')" prop="vc_pztype" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_product_name')" prop="vc_pzname" show-overflow-tooltip></el-table-column>
            </el-table>
            <el-pagination  style="margin-top: 10px;text-align: right"
                            background
                            @current-change="cppageCurrentChange"
                            layout="total,prev, pager, next"
                            :current-page.sync="cpcurrentPage"
                            :total="cptotal"
                            :page-size="cppageSize">
            </el-pagination>
        </div>
        <div>
            <el-input style="width: 220px" class="marr4" clearable size="mini" :placeholder="$t('yewuPM_product_specification')" v-model="ggvc_name">
            </el-input>        <el-button class="marB10" icon="el-icon-search" circle @click="searchggFun " size="mini" ></el-button>

            <el-table class="mrt10" ref="table"　size="mini" :height="tableHeight" border :data="ggtableData" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
                <!--                    <el-table-column label="序号" align="center" type="index" width="50px"></el-table-column>-->
                <el-table-column align="center" :label="$t('yewuPM_product_category_name')" prop="vc_pztype" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_product_name')" prop="vc_pzname" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_specification_name')" prop="vc_name" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_english_name')" prop="vc_ename" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_origin')" prop="vc_cd"></el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_manufacturer')" prop="vc_gykh"></el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_packaging_specification')" prop="vc_bzstyle"></el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_packaging_unit')" prop="vc_bzunit"></el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_conversion_ratio')" prop="f_bl"></el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_measurement_unit')" prop="vc_unit"></el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_single_net_weight')" prop="f_weight"></el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_weight_unit_per_piece')" prop="vc_djunit"></el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_product_attribute')" prop="i_flag">
                    <template slot-scope="scope">
                        <div>{{flagList.find(f=>f.i_flag==scope.row.i_flag).vc_flag}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_goods_nature')" prop="vc_type"></el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_bulk_non_bulk')" prop="i_isbulk">
                    <template slot-scope="scope">
                        <div>{{scope.row.i_isbulk==0?$t('yewuPM_non_bulk'):$t('yewuPM_bulk')}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_sync_to_ecommerce_or_not')" prop="isec">
                    <template slot-scope="scope">
                        <div>{{scope.row.isec?$t('form_correct'):$t('form_deny')}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_piece_counting_or_not')" prop="isjian">
                    <template slot-scope="scope">
                        <div>{{scope.row.isjian?$t('form_correct'):$t('form_deny')}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_use_packaging_or_not')" prop="isusepack">
                    <template slot-scope="scope">
                        <div>{{scope.row.isusepack?$t('form_correct'):$t('form_deny')}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_enabled_or_not')" prop="isusepack">
                    <template slot-scope="scope">
                        <div>{{scope.row.isuse?$t('form_correct'):$t('form_deny')}}</div>
                    </template>
                </el-table-column>

                <el-table-column align="center" :label="$t('yewuPM_mandatory_inspection_on_unloading_or_not')" prop="i_ismustcheck">
                    <template slot-scope="scope">
                        <div>{{scope.row.i_ismustcheck?$t('form_correct'):$t('form_deny')}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_assay_required_or_not')" prop="i_assayres">
                    <template slot-scope="scope">
                        <div>{{scope.row.i_assayres?$t('form_correct'):$t('form_deny')}}</div>
                    </template>
                </el-table-column><el-table-column align="center" :label="$t('yewuPM_financial_cost_accounting')" prop="i_type_sel">
                    <template slot-scope="scope">
                        <div>{{scope.row.i_type_sel?$t('yewuPM_specification_id'):$t('yewuPM_category_id')}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="ERP库存核算" prop="i_pzid_kcjs_sel">
                    <template slot-scope="scope">
                        <div>{{scope.row.i_pzid_kcjs_sel?$t('yewuPM_specification_id'):$t('yewuPM_category_id')}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('yewuPM_erp_statistical_granularity')" prop="i_ispno">
                    <template slot-scope="scope">
                        <div>{{scope.row.i_ispno==2?$t('yewuPM_specification'):$t('yewuPM_batch')}}</div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination  style="margin-top: 10px;text-align: right"
                            background
                            @current-change="ggpageCurrentChange"
                            layout="total,prev, pager, next"
                            :current-page.sync="ggcurrentPage"
                            :total="ggtotal"
                            :page-size="ggpageSize">
            </el-pagination>
        </div>


    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "ChanpinGuige",
        components: {},
        props: {
            data: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                tableHeight:0,
                baseerp:'',
                cptableData:[],
                ggtableData:[],
                cpcurrentPage: 1,
                cppageSize: 20,
                cptotal:0,
                ggcurrentPage: 1,
                ggpageSize: 20,
                ggtotal:0,
                cpvc_name:'',
                ggvc_name:'',
                chooseRow:'',
            }
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
            data:{
                handler(){
                    if(this.data){
                        this.flagList=this.data.flagList;
                    }
                },
                deep:true,
                immediate:true
            }
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.getPztypeContents()
            // this.getProductSpecification()
            this.baseerp=baseerp;
            this.$nextTick(()=>{
                this.onResize();
            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.5-70;
                // if(this.tableHeight<60)this.tableHeight=60;
            },
            chooseRowFun(val){
                this.chooseRow=val
                this.$emit('close',val)
            },
            showggFun(val){
                this.chooseRow=val
                this.getProductSpecification(val)
            },
            async getPztypeContents(){

                let param = {
                    currentPage:this.cpcurrentPage,
                    pageSize:this.cppageSize,
                    vc_name:this.cpvc_name,

                };
                let res = await API.getPztypeContents(param);
                if (res.code == 1) {
                    this.cptableData=res.data.list
                    this.cptotal=res.data.total;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getProductSpecification(val){

                let param = {
                    currentPage:this.ggcurrentPage,
                    pageSize:this.ggpageSize,
                    vc_name:this.ggvc_name,
                    vc_cd:'',
                    vc_gykh:'',
                    vc_model:'',
                    vc_bzstyle:'',
                    vc_material:'',
                    i_pzid:val.i_pzid,
                    i_pztypeid:0,
                    isuse:1,

                };
                let res = await API.getProductSpecification(param);
                if (res.code == 1) {
                    this.ggtableData=res.data.list
                    this.ggtotal=res.data.total;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            searchggFun(){
                this.ggcurrentPage=1;
                //调用列表接口
                this.getProductSpecification();
            },
            searchcpFun(){
                this.cpcurrentPage=1;
                //调用列表接口
                this.getPztypeContents();
            },
            cppageCurrentChange(val){
                // console.log(val,"pageval");
                this.cpcurrentPage=val;
                //调用列表接口
                this.getPztypeContents();
            },
            ggpageCurrentChange(val){
                // console.log(val,"pageval");
                this.ggcurrentPage=val;
                //调用列表接口
                this.getProductSpecification(this.chooseRow);
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>